export const IS_LEGACY_THEME_ALLOWED = 'isLegacyThemeAllowed';
export const DefaultThemes = {
  DEFAULT: 'canvas',
  LEGACY: 'legacy'
};